React = require 'react'
_ = require 'underscore'
Label = require 'models/label'
t = require('views/internal/recup-with-helpers')('boards_page_up_next')
localizeCount = require 'lib/localize-count'
track = require 'debug/track'
TFM = require 'lib/markdown/tfm'
MemberAvatar = require 'views/member/member-avatar-react'
{ CanonicalCard } = require 'views/canonical-card/canonical-card-components'

module.exports = class BoardsPageUpNextCardComponent extends React.Component
  displayName: 'BoardsPageUpNextCardComponent'

  constructor: (props) ->
    @trackOnClickCanonicalCard = @trackOnClickCanonicalCard.bind(@)
    @dismissCard = @dismissCard.bind(@)

  dismissCard: ->
    track('Boards View', 'Up Next', 'Clicked dismiss')
    @props.dismissCard(@props.card.get('id'))

  trackOnClickCanonicalCard: ->
    track('Boards View', 'Up Next', 'Clicked on card')

  render: t.renderable ->
    { dueSoon, card, mentions } = @props

    t.li '.boards-page-board-section-list-item', { key: card.get('id') }, =>
      badges = card.get('badges')

      t.div { onClick: @trackOnClickCanonicalCard }, ->
        t.tag CanonicalCard, {
          board: card.getBoard()
          boardClassName: 'canonical-stretch'
          canRemove: false
          card
          cardClassName: 'canonical-stretch'
          labels: card.getLabels().sort(Label.compare)
          list: card.getList()
          members: card.memberList.models
          numNotifications: 0
        }

      t.div '.text-snippet-container.quiet', =>
        if badges.due && dueSoon && mentions.length
          t.div '.text-snippet-icons-container', ->
            t.span { class: 'text-snippet-icon icon-lg icon-clock' }
            _.uniq(mentions, false, (mention) -> mention.get('id'))
              .slice(0, 2)
              .map (mention) ->
                t.span '.text-snippet-icon', { key: mention.get('id') }, ->
                  t.createElement MemberAvatar, mention.toJSON()
          t.span '.text-snippet', ->
            t.format 'due'
            t.text ' '
            t.span '.date', { 'data-date': badges.due }
            t.text ' '
            t.format 'and'
            t.text ' '
            t.text localizeCount 'up-next-mentions', mentions.length

        else if badges.due && dueSoon
          t.div '.text-snippet-icons-container', ->
            t.span { class: 'text-snippet-icon icon-lg icon-clock' }
          t.span '.text-snippet', ->
            t.format 'due'
            t.text ' '
            t.span '.date', { 'data-date': badges.due }

        else if mentions.length
          t.div '.text-snippet-icons-container', ->
            _.uniq(mentions, false, (mention) -> mention.get('id'))
              .slice(0, 3)
              .map (mention) ->
                t.span '.text-snippet-icon', { key: mention.get('id') }, ->
                  t.createElement MemberAvatar, mention.toJSON()

          t.span '.text-snippet', ->
            t.text localizeCount 'up-next-mentions', mentions.length

        t.a '.dismiss', { href: '#', onClick: @dismissCard }, ->
          t.div '.dismiss-text', ->
            t.format 'dismiss'
          t.span '.dismiss-icon', ->
            t.text '×'



// WEBPACK FOOTER //
// ./app/scripts/views/member/boards-page-up-next-card-component.coffee